@if (dialogElements) {
	<stages-dialog2 #dialog>
		<stages-dialog-header />
		<div class="content">
			<h1>{{ countMessageKey }}</h1>
			<ul class="list dense">
				@for (entry of dialogElements; track entry) {
					<li class="list-item">
						<div class="label">
							<div class="text center">
								<h4 [ngClass]="entry.class">{{ entry.label }}</h4>
								@if (entry.sameLabelExists) {
									<h4
										class="error-color"
										translate="process.element.dependentElementsList.confirmTemplate.sameNameExists"
									></h4>
								}
							</div>
						</div>
					</li>
				}
			</ul>
		</div>
		<footer>
			<div class="buttons">
				<button class="button sm cancel" (click)="close()" translate="cancel"></button>
				<button
					class="button sm save"
					(click)="applyTemplate()"
					[disabled]="dependentElementIdsWithoutDuplicates.length === 0"
				>
					@if (!applyInProgress) {
						<span translate="add"></span>
					}
					@if (applyInProgress) {
						<stages-spin size="s"></stages-spin>
					}
				</button>
			</div>
		</footer>
	</stages-dialog2>
}
